import { trendingItems } from "@/mocks/gossip";

const HERO_IMG =
  "https://readdy.ai/api/search-image?query=Editorial%20magazine%20style%20dramatic%20collage%20of%20smartphone%20screens%20with%20social%20media%20notification%20icons%2C%20floating%20debate%20and%20gossip%20chat%20bubbles%2C%20warm%20cream%20background%20with%20bold%20coral%20red%20and%20amber%20gold%20accents%2C%20dynamic%20overlapping%20polaroid%20frames%2C%20high%20detail%20editorial%20illustration%2C%20playful%20yet%20sophisticated%2C%20clean%20composition&width=1320&height=820&seq=gossip-hero-main&orientation=landscape";

const SIDE_A =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20portrait%20poster%20of%20a%20fit%20athletic%20influencer%20in%20silhouette%20holding%20a%20dumbbell%2C%20warm%20amber%20gold%20and%20coral%20red%20gradient%20background%2C%20dramatic%20spotlight%2C%20question%20mark%20and%20magnifying%20glass%20elements%2C%20magazine%20cover%20vibe%2C%20no%20visible%20face%2C%20high%20detail%20editorial%20illustration&width=600&height=720&seq=gossip-hero-a&orientation=portrait";

const SIDE_B =
  "https://readdy.ai/api/search-image?query=Stylized%20editorial%20poster%20of%20a%20beauty%20influencer%20silhouette%20with%20makeup%20brush%20and%20cosmetic%20palette%2C%20coral%20red%20and%20deep%20cream%20background%2C%20before%20after%20split%20lighting%2C%20magnifying%20glass%20and%20contrast%20arrow%20elements%2C%20no%20visible%20face%2C%20high%20detail%20editorial%20magazine%20illustration&width=600&height=720&seq=gossip-hero-b&orientation=portrait";

export default function Hero() {
  return (
    <section id="top" className="relative overflow-hidden pt-16 bg-background-50">
      <div className="mx-auto max-w-[1320px] px-4 md:px-6 py-10 md:py-16 grid lg:grid-cols-[1.15fr_1fr] gap-10 lg:gap-14 items-center">
        {/* left copy */}
        <div>
          <div className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3.5 py-1.5 text-xs font-medium text-primary-700">
            <span className="relative flex h-2 w-2">
              <span className="absolute inline-flex h-full w-full rounded-full bg-primary-500 animate-pulse-soft"></span>
              <span className="relative inline-flex h-2 w-2 rounded-full bg-primary-500"></span>
            </span>
            海外吃瓜 · 网红黑料聚合站
          </div>

          <h1 className="mt-5 font-heading font-black text-[34px] leading-tight md:text-5xl text-foreground-950">
            全网海外网红
            <span className="text-primary-600">黑料翻车</span>
            现场，
            <br className="hidden md:block" />
            一次吃透完整过程
          </h1>

          <p className="mt-5 text-base leading-relaxed text-foreground-700 max-w-xl">
            聚合海外网红黑料与博主翻车现场，集中呈现争议动态、前后对比截图与关键人物档案。
            按话题整理好材料——想看塌房全程、证据梳理或扒皮细节，这里都能直接找到。
          </p>

          <div className="mt-7 flex flex-wrap gap-3">
            <a
              href="#hot"
              className="inline-flex items-center gap-2 rounded-full bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              查看今日热瓜 <i className="ri-arrow-right-line"></i>
            </a>
            <a
              href="#scene"
              className="inline-flex items-center gap-2 rounded-full bg-background-100 border border-background-300 px-6 py-3 text-sm font-medium text-foreground-900 hover:border-primary-300 hover:text-primary-700 transition-colors whitespace-nowrap"
            >
              <i className="ri-time-line"></i> 逐帧还原现场
            </a>
          </div>

          <div className="mt-9 grid grid-cols-3 gap-4 max-w-md">
            <div className="flex flex-col">
              <span className="font-latin text-3xl md:text-4xl text-accent-600 leading-none">1.2k+</span>
              <span className="mt-1.5 text-xs text-foreground-600">收录事件档案</span>
            </div>
            <div className="flex flex-col">
              <span className="font-latin text-3xl md:text-4xl text-accent-600 leading-none">98%</span>
              <span className="mt-1.5 text-xs text-foreground-600">逐帧还原覆盖率</span>
            </div>
            <div className="flex flex-col">
              <span className="font-latin text-3xl md:text-4xl text-accent-600 leading-none">24h</span>
              <span className="mt-1.5 text-xs text-foreground-600">实时跟踪更新</span>
            </div>
          </div>
        </div>

        {/* right visual collage */}
        <div className="relative">
          <div className="relative overflow-hidden rounded-3xl">
            <img
              src={HERO_IMG}
              alt="海外网红黑料与博主翻车事件聚合的编辑风封面插图"
              className="w-full h-[300px] md:h-[400px] object-top object-cover"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-background-950/25 to-transparent"></div>
          </div>

          <div className="absolute -bottom-8 -left-4 hidden md:block w-36 lg:w-44 rotate-[-4deg] rounded-2xl overflow-hidden border-4 border-background-50 shadow-none">
            <img src={SIDE_A} alt="健身博主翻车档案编辑海报" className="w-full h-44 object-top object-cover" />
          </div>
          <div className="absolute -bottom-4 -right-2 hidden md:block w-32 lg:w-36 rotate-[5deg] rounded-2xl overflow-hidden border-4 border-background-50">
            <img src={SIDE_B} alt="美妆博主翻车档案编辑海报" className="w-full h-40 object-top object-cover" />
          </div>

          <div className="absolute top-4 right-4 rounded-2xl bg-background-50/95 backdrop-blur px-4 py-3 flex items-center gap-3">
            <span className="flex items-center justify-center w-10 h-10 rounded-xl bg-secondary-100 text-secondary-700">
              <i className="ri-fire-fill text-lg"></i>
            </span>
            <div className="leading-tight">
              <p className="font-latin text-xl text-foreground-950">#1 趋势</p>
              <p className="text-[11px] text-foreground-600">健身区体脂造假</p>
            </div>
          </div>
        </div>
      </div>

      {/* marquee ticker */}
      <div className="mt-6 border-y border-background-200 bg-background-100 py-3 overflow-hidden">
        <div className="flex w-max animate-marquee items-center">
          {[...trendingItems, ...trendingItems].map((item, idx) => (
            <span
              key={`${item.id}-${idx}`}
              className="flex items-center gap-2 px-6 text-sm text-foreground-800 whitespace-nowrap"
            >
              <i className="ri-broadcast-line text-primary-500"></i>
              <span className="font-medium">{item.person}</span>
              <span className="text-foreground-500">·</span>
              <span>{item.title}</span>
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}